export enum BlockTitleVariant {
  default = 'default', // with text (?)
  tagged = 'tagged',
  buttoned = 'buttoned',
}
